export const PageSource_RequestHome = 'RequestHome';
export const PageSource_RequestPendingRequests = 'RequestPendingRequests';
export const PageSource_RequestRecentHistory = 'RequestRecentHistory';
export const PageSource_HRRequestHome = 'HRRequestHome';
export const PageSource_HRRequestPendingRequests = 'HRRequestPendingRequests';
export const PageSource_HRRequestRecentHistory = 'HRRequestRecentHistory';
export const APPROVAL_CENTRAL = 'Approval central';
export const CALENDAR = 'Calendar';
export const PAGE_PUNCH_EDIT = 'PUNCHEDIT';